import dayjs from 'dayjs/esm';
import 'dayjs/esm/locale/da';
import isoWeek from 'dayjs/esm/plugin/isoWeek';
import utc from 'dayjs/esm/plugin/utc';

dayjs.extend(isoWeek);
dayjs.extend(utc);
dayjs.locale('da');
